<template>
  <div class="Child">
    <vxe-toolbar
      id="toolbarId_or4"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="Getdistr()"> 查询 </el-button>
        <el-button @click="getSelectEvent"> 确定 </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      :loading="loading"
      row-id="id"
      height="500"
      :data="tableData"
      export-config
      :checkbox-config="{ highlight: true }"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column field="name" title="实际承运人姓名" min-width="140" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="选择实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="实际承运人手机号"
          min-width="150"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="选择实际承运人手机号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="linkMan" title="车队名称" min-width="150" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.linkMan"
            placeholder="选择车队名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLoadStatusName"
          title="负载状态"
          min-width="130"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleLoadStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseNumber"
          title="车牌号"
          min-width="150"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicenseNumber"
            placeholder="选择车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleOutsideDimensions"
          title="外廓尺寸(mm)"
          min-width="150"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleOutsideDimensions"
            placeholder="外廓尺寸"
            clearable
            disabled
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLoadWeightName"
          title="载重"
          min-width="150"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLoadWeightName"
            placeholder="载重"
            clearable
            disabled
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleClassificationName"
          title="车型"
          min-width="180"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleClassification"
            placeholder="请选择车型"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import { tedDriver, savePushTarget } from "@/api/orderform";

export default {
  props: {
    huoyuan: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      distrdata: {
        pushTarget: "",
        code: ""
      },
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        driverType: 3,
        authStatus: 3,
        isFreeze: 0,
        name: "",
        phone: "",
        headImg: "",
        linkMan: "",
        vehicleLicenseNumber: "",
        vehicleLength: "",
        vehicleClassification: "",
        vehicleLoadStatus: "",
        authStatusExt: "3",
        branchCodeExt: ""
      },
      Pagingconf: [],
      options: [
        {
          value: "0",
          label: "空载"
        },
        {
          value: "1",
          label: "负载"
        }
      ],
      huoycode: ""
    };
  },
  methods: {
    close() {
      this.listQuery = {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        driverType: 3,
        authStatus: 3,
        isFreeze: 0,
        name: "",
        phone: "",
        headImg: "",
        linkMan: "",
        vehicleLicenseNumber: "",
        vehicleLength: "",
        vehicleClassification: "",
        vehicleLoadStatus: "",
        authStatusExt: "3",
        branchCodeExt: ""
      };
    },
    async RefreshList() {
      this.listQuery = {
        branchCodeExt: this.listQuery.branchCodeExt,
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      };
      await this.Getdistr();
    },
    // 查询
    Getdistr(params) {
      if (params) {
        this.listQuery = {
          branchCodeExt: this.listQuery.branchCodeExt,
          pageNum: 1,
          pageSize: 20,
          sortField: "",
          sortType: "",
          total: 0
        };
        this.huoycode = params.huoyuan || this.huoycode;
        this.listQuery.branchCodeExt = params.branchCode;
      }
      this.loading = true;
      return new Promise(resolve => {
        tedDriver(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          response.data.total > 10000
            ? (this.Pagingconf = [20, 30, 50, 100, 10000])
            : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
          this.loading = false;
          resolve();
        });
      });
    },

    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.Getdistr();
    },
    getSelectEvent() {
      const _selectRecords = this.$refs.xTable.getSelectRecords();
      if (_selectRecords.length === 0) {
        this.$message({ message: "请选择推送人员", type: "warning" });
        return false;
      }
      //this.distrdata.code = this.huoycode;
      this.distrdata.code = this.huoyuan;
      const tempArr = [];
      _selectRecords.forEach(item => {
        tempArr.push(item.partyCode);
      });
      this.distrdata.pushTarget = tempArr.join(",");
      savePushTarget(this.distrdata).then(response => {
        this.$message({
          type: "success",
          message: "推送成功!"
        });
      });
    }
  }
};
</script>

<style></style>
